<template>
  <div class="bggray">
    <div class="con100" v-if="orderInfo.orderDetailList">
      <app-header />
      <div class="orderWrap">
        <div class="orderNav">
          <span class="cur">确认购买信息</span>
          <span class="cur">选择支付方式</span>
          <span class="cur">购买成功</span>
        </div>
        <div class="mod orderInfo" >
          <h3 class="title">订单详情</h3>
          <ul class="column5">
            <li>
              <div>产品名称</div>
              <div>订单编号</div>
              <div>数量</div>
              <div>实付款（元）</div>
              <div>支付方式</div>
            </li>
            <li>
              <div>{{orderInfo.orderDetailList[0].goodsName}}</div>
              <div>{{orderInfo.order.id}}</div>
              <div>1/{{stockUnit}}</div>
              <div>{{orderInfo.orderDetailList[0].payAmount}}</div>
              <div v-if="orderInfo.order.payMode == 0">未支付</div>
              <div v-else-if="orderInfo.order.payMode == 3">线下支付</div>
              <div v-else-if="orderInfo.order.payMode == 4">点卡</div>
              <div v-else-if="orderInfo.order.payMode == 7">快钱</div>
              <div v-else-if="orderInfo.order.payMode == 11 || orderInfo.order.payMode == 29">支付宝</div>
              <div v-else-if="orderInfo.order.payMode == 23">微信</div>
              <div v-else-if="orderInfo.order.payMode == 25 || orderInfo.order.payMode == 26 || orderInfo.order.payMode == 27">银联</div>
              <div v-else>其他</div>
            </li>
          </ul>
        </div>
        <div class="mod pl address">
          <h3 class="title">收货地址</h3>
          <p>收件人：{{orderInfo.orderDelivery.consignee}}</p>
          <p>电话：{{orderInfo.orderDelivery.consigneePhone}}</p>
          <p>地址：{{orderInfo.orderDelivery.consigneeAddress}}</p>
          <div class="btn-list">
            <!-- <a class="btn-normal" href="#" @click="download">下载软件</a> -->
            <router-link :to="'/'" class="btn-normal">完成</router-link>
          </div>
          
        </div>
      </div>
    </div>
    <div class="con100-footer">
      <!-- <app-footer /> -->
    </div>
  </div>
</template>

<script>
import AppHeader from "@/components/common/AppHeader.vue";
// import AppFooter from "@/components/common/AppFooter.vue";

export default {
  components: {
    AppHeader,
    // AppFooter
  },
  data() {
    return {
      id: this.$route.params.id,
      userName: this.$storage.getUserName(),
      orderInfo: {},
      stockUnit: ''
    };
  },
  created() {
    this.getData();
  },
  mounted() {
  },
  methods: {
    getData() {
      this.$get("/order/v1/queryById?id=" + this.id)
        .then(response => {
          if (response.code === 0) {
            this.orderInfo = response.data;
            this.stockUnit = response.data.stockUnit
          } else if (response.code != 100) {
            this.$global.alert(response.msg);
          }
        })
        .catch(err => {
          this.$global.alertAndGoHistory("网络异常，请稍后重试。");
        });
    },
    download() {
      this.$get("/product/query?id=" + this.orderInfo.productId).then(
        response => {
          if (response.code === 0 && response.data.downloadUrl != 0) {
            window.location.href = response.data.downloadUrl;
          } else {
            window.open("http://www.gw.com.cn/download.shtml");
          }
        }
      );
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/styles/scss/order.scss";
.btn-list {
  a {
    bottom: 40px;
    &:first-child {
      right: 290px;
    }
  }
}
.dispatch-list {
  padding-bottom: 40px;
}
.btn-normal {
  &:hover{
    background: #1460db;
  }
}
.orderWrap .address{
  padding-bottom: 15px;
  p{
    margin-bottom: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/order/OrderDetail.vue